import { useState, useEffect } from 'react';
import { billService } from '../services/billService';

/**
 * Custom hook to fetch recent bills with their orders
 * @param {number} tableId - Filter by specific table (null for all tables)
 * @param {number} limit - Number of recent bills to fetch
 * @param {number} days - Number of days to look back
 * @returns {Object} { recentBills, loading, error, refetch }
 */
export const useRecentBills = (tableId = null, limit = 50, days = 1) => {
  const [recentBills, setRecentBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRecentBills = async () => {
    try {
      setLoading(true);
      setError(null);

      // Build query params
      const params = {
        limit,
        days,
        ...(tableId && { tableId })
      };

      // Fetch from API
      const response = await billService.getRecentBills(params);

      // Handle different response structures
      let billsData = [];
      if (Array.isArray(response)) {
        billsData = response;
      } else if (Array.isArray(response?.data)) {
        billsData = response.data;
      }

      setRecentBills(billsData);
    } catch (err) {
      console.error('Failed to fetch recent bills:', err);
      setError(err.message || 'Failed to fetch recent bills');
      setRecentBills([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentBills();
  }, [tableId, limit, days]);

  return {
    recentBills,
    loading,
    error,
    refetch: fetchRecentBills
  };
};

export default useRecentBills;
